// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_ModeloResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /contratos/modelo e POST /contratos/modelo_salvar — o modelo padrão vigente (Full). */
import type { Contratos_CampoRow } from './Contratos_CampoRow'
import type { Contratos_ClausulaRow } from './Contratos_ClausulaRow'
import type { Contratos_VersaoRow } from './Contratos_VersaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contratos_ModeloResponseDados {
versao: number
clausulas: Contratos_ClausulaRow[]
campos: Contratos_CampoRow[]
versoes: Contratos_VersaoRow[]
}

export type Contratos_ModeloResponse = ApiResponse<Contratos_ModeloResponseDados>;

registerResponseContract('Contratos_ModeloResponse', {
  versao:    { type: 'number',  required: true },
  clausulas: {
    type: 'array',
    required: true,
    items: {
      chave:  { type: 'string',  required: false },
      titulo: { type: 'string',  required: false },
      texto:  { type: 'string',  required: false },
      fixa:   { type: 'boolean', required: false },
    },
  },
  campos: {
    type: 'array',
    required: true,
    items: {
      campo:  { type: 'string',  required: false },
      rotulo: { type: 'string',  required: false },
    },
  },
  versoes: {
    type: 'array',
    required: true,
    items: {
      versao:     { type: 'number',  required: true },
      criado_por: { type: 'string',  required: false },
      criado_em:  { type: 'string',  required: true },
    },
  },
})
